import { IJsonQuery } from './types/jsonQuery';

import { getTermValue } from './helpers';

export function getApartments(jsonQuery: IJsonQuery): boolean | null {
  const withoutApartments = getTermValue('only_flat')(jsonQuery);
  const onlyApartments = getTermValue('apartment')(jsonQuery);

  switch (true) {
    case !withoutApartments && onlyApartments:
      return true;

    case withoutApartments && !onlyApartments:
      return false;
  }

  return null;
}
